module.exports = __webpack_public_path__ + "img/japan-eye-and-ear-diseases-female.a738b3a9.png";